import { useDocsDataModelStore } from '@/models/docs-data/docsData';
import { ResourceNotFound } from '@/shared/constant/ResourceData';
import { ModelType } from '@tarslib/types/lib/common';
import React from 'react';
import { ApiFolderContent } from '../api-folder-content/ApiFolderContent';
import { CustomEndpointContent } from '../custom-endpoint-content/CustomEndpointContent';
import { DocContent } from '../doc-content/DocContent';
import { useSearchVariablesInURL } from '../environment-modal/hooks/useSearchVariablesInURL';
import { HttpApiContent } from '../http-api-content/HttpApiContent';
import { WebSocketApiContent } from '../webSocket-api-content/WebSocketApiContent';
import { ResourceNotFoundContent } from './components/resource-not-found-content/ResourceNotFoundContent';

export const DocsResource = React.memo(function DocsResourceComponent() {
  const resourceData = useDocsDataModelStore((x) => x.resourceData);

  useSearchVariablesInURL();

  return (
    <div className="w-full">
      {resourceData.type === ModelType.Doc && <DocContent value={resourceData.data} />}

      {resourceData.type === ModelType.HttpApi && (
        <HttpApiContent value={resourceData.data} extraData={resourceData.extraData} />
      )}

      {resourceData.type === ModelType.ApiFolder && (
        <ApiFolderContent value={resourceData.data} extraData={resourceData.extraData} />
      )}

      {resourceData.type === ModelType.CUSTOM_ENDPOINT && (
        <CustomEndpointContent value={resourceData.data} />
      )}

      {resourceData.type === ModelType.WebSocketApi && (
        <WebSocketApiContent value={resourceData.data} />
      )}

      {resourceData.type === ResourceNotFound && <ResourceNotFoundContent />}
    </div>
  );
});
